import http from "../http";

export function useDemographic() {
  const getDemographics = () => http.get('/api/demographics');
  const isAge = (category) => category === 'AGE';
  const isGender = (gender) => gender === 'GENDER';

  return {
    getDemographics,
    isAge,
    isGender,
  }
}
